import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { suspendCards } from '../api/simActionsApi';

export const useSuspendMutation = (
  options?: Omit<UseMutationOptions<void, Error, { iccids: string[] }, unknown>, 'mutationFn'>,
) => {
  return useMutation({
    ...options,
    mutationFn: (props) => {
      return suspendCards(props);
    },
  });
};
